module.exports = __webpack_public_path__ + "static/media/Indian_Institute_of_Technology_Goa_Logo.391d9e05.svg";